export default {
 "head.index": "홈"
};
